(function (angular) {
    'use strict';

    angular.module('chat2')

        /**
         *
         */
        .factory('featureService',
            ['$http', '$q', 'portalConfig',
                function ($http, $q, portalConfig) {

                    var urlBase = portalConfig.urlBase;

                    var fac = {
                        isFeatureEnabledForAcount: isFeatureEnabledForAcount,
                    };

                    return fac;


                    function requestComplete(response) {
                        return response.data;
                    }

                    function requestFailed(error) {
                        console.error(JSON.stringify(error));
                        return $q.reject(error);
                    }


                    function isFeatureEnabledForAcount(featureName) {
                        // urlBase = 'http://localhost:8002';
                        return $http.get(`${urlBase}/feature/${featureName}/account`)
                            .then(requestComplete)
                            .catch(requestFailed);
                    }

                }]);
})(window.angular);
